module.exports = __webpack_public_path__ + "img/carte-bleue-old.f0e89059.png";